export const RuntimeVersionAttribute = "data-runtime-version";
export const ElementRootAttribute = "data-alchemy-element-root";
